import React, { Component, Fragment } from "react";
import { Trans, withTranslation, WithTranslation } from "react-i18next";

import Button from "js/react/components/Button2";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";

interface SuccessfulPurchaseDialogProps extends WithTranslation {
    productDisplayName: string;
    showTrial: boolean;
    trialExpirationDate: string;
    callToActionText: string;
    message?: string;
    additionalMessage?: string;
    trialDurationDays?: number;
    onCallToActionClick: () => void;
}

class SuccessfulPurchaseDialog extends Component<SuccessfulPurchaseDialogProps> {
    fadeOutTimeout = null;
    callToActionTimeout = null;

    renderNonTrialSuccessMessage() {
        const { t, message, productDisplayName } = this.props;
        if (message) {
            return message;
        }
        return (
            <Fragment>
                <Trans
                    i18nKey="You have successfully upgraded to <product>{{productDisplayName}}</product>."
                    values={{ productDisplayName }}
                    components={{ product: <span /> }}
                />
            </Fragment>
        );
    }

    async componentDidMount() {
        const { onCallToActionClick } = this.props;
        this.fadeOutTimeout = setTimeout(() => {
            this.setState({ fadeOut: true });
            this.callToActionTimeout = setTimeout(() => {
                onCallToActionClick();
            }, 750);
        }, 1500);
    }

    componentWillUnmount() {
        clearTimeout(this.fadeOutTimeout);
        clearTimeout(this.callToActionTimeout);
    }

    handleButtonClick = () => {
        const { onCallToActionClick } = this.props;
        clearTimeout(this.fadeOutTimeout);
        clearTimeout(this.callToActionTimeout);
        onCallToActionClick();
    }

    render() {
        const { t, productDisplayName, showTrial, trialExpirationDate, callToActionText, additionalMessage, trialDurationDays = 14 } = this.props;

        if (showTrial) {
            return (
                <BeautifulDialog preventClose >
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">
                                <Trans
                                    i18nKey="Great! You've just started your {{days}}-day free trial for Beautiful.ai {{productDisplayName}}."
                                    values={{ days: trialDurationDays, productDisplayName }}
                                />
                            </div>
                            <div className="receipt">
                                {t("Cancel anytime before {{date}} and you will not be charged.", { date: trialExpirationDate })}
                            </div>
                            {additionalMessage && <div className="receipt">{additionalMessage}</div>}
                            <Button onClick={this.handleButtonClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>

            );
        } else {
            return (
                <BeautifulDialog preventClose>
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">
                                {this.renderNonTrialSuccessMessage()}
                            </div>
                            <div className="receipt">{t("A receipt will be sent to your email shortly.")}</div>
                            {additionalMessage && <div className="receipt">{additionalMessage}</div>}
                            <Button onClick={this.handleButtonClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            );
        }
    }
}

export default withTranslation()(SuccessfulPurchaseDialog);
